export const validatePolicyParams = ({
  title,
  file,
}: {
  title: string | null;
  file: string | null;
}) => {
  let parsedTitle = title
  let parsedFile = file
  if (title) {
    parsedTitle = decodeURIComponent(title)
  }
  if (file) {
    parsedFile = decodeURIComponent(file)
    try {
      const parsedFileUrl = new URL(parsedFile)
      parsedFile =
        // Prod assets origin
        parsedFileUrl.origin.match(
          /^https:\/\/assets.*\.tandemdiabetes\.com$/g,
        ) ||
        // Non prod assets origin
        parsedFileUrl.origin.match(
          /^https:\/\/stsourcesassetsdev\.blob\.core\.windows\.net$/g,
        )
          ? parsedFile
          : null
    } catch {
      parsedFile = null
    }
  }
  return {
    parsedFile,
    parsedTitle,
  }
}
